import { Alert, Autocomplete, Card, Grid, Snackbar, TextField } from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useQuery } from "@tanstack/react-query";
import MDAutocomplete from "components/MDAutocomplete";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { use, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { LocalizationProvider } from "@mui/x-date-pickers";
import DayjsUtils from "@date-io/dayjs";
import dayjs from "dayjs";
// import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MDTextField from "components/MDTextField";
// import TextField from '@mui/material/TextField';
import PropTypes from "prop-types";
const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "2px 8px",
  color: "white",
  backgroundColor: "#90B494",
}));

const Groups = styled("ul")({
  padding: 0,
});

function GreenSchoolAdd() {
  const navigate = useNavigate();
  const { id: schoolId } = useParams();
  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const { vertical, horizontal, open, message, severity } = state;
  const [calendarOpen, setCalendarOpen] = useState(false);

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  const fetchDistrict = async () => {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/districts/all`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data.data;
  };

  let {
    data: districtData = [],
    error: districtError,
    isLoading: districtIsLoading,
  } = useQuery({
    queryKey: ["fetchDistrict"],
    queryFn: fetchDistrict,
    retry: false,
  });

  const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/;

  const validationSchema = () => {
    return Yup.object().shape({
      txtGroup: Yup.string()
        .required("Phase is required")
        .max(50, "Group must be at most 50 characters"),
      intDistrict: Yup.number().nullable(),
      txtSchoolName: Yup.string()
        .required("School name is required")
        .max(255, "School name must be at most 255 characters"),
      txtTentativeDate: Yup.string().nullable(),
      txtAgri1: Yup.string().nullable(),
      txtAgri2: Yup.string().nullable(),
      txtAgri3: Yup.string().nullable(),
      horti1: Yup.string().nullable(),
      horti2: Yup.string().nullable(),
      hiring1: Yup.string().nullable(),
      hiring2: Yup.number()
        .typeError("Only numbers are allowed")
        .nullable(),
      remarks: Yup.string()
        .max(5000, "Remarks must be at most 5000 characters"),
      Expenditure: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      Amount: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      amountReceived: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      expenditureIncurred: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      expenditureToBeIncurred: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      balanceAvailable: Yup.string().matches(/^[\d,.]*$/, "Only numbers, commas, and dots are allowed"),
      ucStatus: Yup.string().nullable().max(50, "UC Status must be at most 50 characters"),
      txtAgri1Agency: Yup.string().when("txtAgri1", {
        is: (val) => val && val !== "0% - Not yet Started",
        then: (schema) => schema.required("Implementing Agency is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      txtAgri2Agency: Yup.string().when("txtAgri2", {
        is: (val) => val && val !== "0% - Not yet Started",
        then: (schema) => schema.required("Implementing Agency is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      txtAgri3Agency: Yup.string().when("txtAgri3", {
        is: (val) => val && val !== "0% - Not yet Started",
        then: (schema) => schema.required("Implementing Agency is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      horti1Agency: Yup.string().when("horti1", {
        is: (val) => val && val !== "0% - Not yet Started",
        then: (schema) => schema.required("Implementing Agency is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      horti2Agency: Yup.string().when("horti2", {
        is: (val) => val && val !== "0% - Not yet Started",
        then: (schema) => schema.required("Implementing Agency is required"),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  };
  const formik = useFormik({
    initialValues: {
      txtGroup: "",
      intDistrict: "",
      txtSchoolName: "",
      txtAgri1: "0% - Not yet Started",
      txtAgri2: "0% - Not yet Started",
      txtAgri3: "0% - Not yet Started",
      horti1: "0% - Not yet Started",
      horti2: "0% - Not yet Started",
      hiring1: "0% - Not yet Started",
      hiring2: "",
      remarks: "",
      txtTentativeDate: null,
      Expenditure: "",
      Amount: "",
      amountReceived: "",
      expenditureIncurred: "",
      expenditureToBeIncurred: "",
      balanceAvailable: "",
      ucStatus: "",
      txtAgri1Agency: "",
      txtAgri2Agency: "",
      txtAgri3Agency: "",
      horti1Agency: "",
      horti2Agency: "",
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      try {
        const url = schoolId
          ? `${process.env.REACT_APP_API_URL}/green-school/${formik.values.basic_id || schoolId}`
          : `${process.env.REACT_APP_API_URL}/green-school/basic-info/add`;

        const method = schoolId ? "put" : "post";

        // Strip commas from numeric fields before submission
        const processedValues = {
          ...values,
          txtTentativeDate: values.txtTentativeDate
            ? values.txtTentativeDate.format("YYYY-MM-DD")
            : null,
          Expenditure: values.Expenditure?.toString().replace(/,/g, ""),
          Amount: values.Amount?.toString().replace(/,/g, ""),
          amountReceived: values.amountReceived?.toString().replace(/,/g, ""),
          expenditureIncurred: values.expenditureIncurred?.toString().replace(/,/g, ""),
          expenditureToBeIncurred: values.expenditureToBeIncurred?.toString().replace(/,/g, ""),
          balanceAvailable: values.balanceAvailable?.toString().replace(/,/g, ""),
          hiring2: values.hiring2?.toString().replace(/,/g, ""),
        };

        // console.log("Submitting values:", processedValues);

        const response = await axios({
          method,
          url,
          data: { values: processedValues },
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        if (response.data.status === 200) {
          setState({
            ...state,
            open: true,
            severity: "success",
            message: response.data.message,
          });

          setTimeout(() => {
            navigate("/green-school");
          }, 2000);
        }
      } catch (error) {
        console.log("Submission error:", error);

        if (error.response?.status === 401 || error.response?.status === 500) {
          setState({
            ...state,
            open: true,
            severity: "error",
            message: error.response.data.error,
          });
        } else if (error.response?.status === 400 && error.response?.data?.details) {
          const serverErrors = {};
          const details = error.response.data.details;

          if (details.intDistrict) serverErrors.intDistrict = details.intDistrict[0];
          if (details.txtGroup) serverErrors.txtGroup = details.txtGroup[0];
          if (details.txtSchoolName) serverErrors.txtSchoolName = details.txtSchoolName[0];
          if (details.txtAgri1) serverErrors.txtAgri1 = details.txtAgri1[0];
          if (details.txtAgri2) serverErrors.txtAgri2 = details.txtAgri2[0];
          if (details.txtAgri3) serverErrors.txtAgri3 = details.txtAgri3[0];
          if (details.horti1) serverErrors.horti1 = details.horti1[0];
          if (details.horti2) serverErrors.horti2 = details.horti2[0];
          if (details.hiring1) serverErrors.hiring1 = details.hiring1[0];
          if (details.hiring2) serverErrors.hiring2 = details.hiring2[0];
          if (details.remarks) serverErrors.remarks = details.remarks[0];

          formik.setErrors(serverErrors);
        } else {
          setState({
            ...state,
            open: true,
            severity: "error",
            message: "Something went wrong. Please try again.",
          });
        }
      }
    },
  });

  useEffect(() => {
    if (schoolId) {
      const fetchSchoolDetails = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/green-school/${schoolId}`,
            {
              withCredentials: true,
            }
          );

          if (response.data.status === 200) {
            const school = response.data.data;

            formik.setValues({
              ...formik.initialValues, // Start with defaults for missing fields
              ...school,
              basic_id: school.basic_id,
              txtGroup: school.group_name || "",
              intDistrict: school.district_id || "",
              txtSchoolName: school.school_name || "",
              txtAgri1: school.agriculture_1 || "0% - Not yet Started",
              txtAgri2: school.agriculture_2 || "0% - Not yet Started",
              txtAgri3: school.agriculture_3 || "0% - Not yet Started",
              horti1: school.horticulture_1 || "0% - Not yet Started",
              horti2: school.horticulture_2 || "0% - Not yet Started",
              hiring1: school.hiring || "0% - Not yet Started",
              hiring2: school.hiring_completed ?? "",
              remarks: school.remarks || "",
              txtTentativeDate: school.date_of_inspection ? dayjs(school.date_of_inspection) : null,
              Expenditure: school.committed_expenditure ?? "",
              Amount: school.unused_amount ?? "",
              amountReceived: school.amount_received ?? "0",
              expenditureIncurred: school.expenditure_incurred ?? "0",
              expenditureToBeIncurred: school.expenditure_to_be_incurred ?? "0",
               balanceAvailable: school.balance_available ?? "0",
              ucStatus: school.uc_status || "",
              txtAgri1Agency: school.agriculture_1_agency || "",
              txtAgri2Agency: school.agriculture_2_agency || "",
              txtAgri3Agency: school.agriculture_3_agency || "",
              horti1Agency: school.horticulture_1_agency || "",
              horti2Agency: school.horticulture_2_agency || "",
            });
          }
        } catch (error) {
          console.error("❌ Failed to fetch school details", error);
        }
      };

      fetchSchoolDetails();
    }
  }, [schoolId]);

  const options = [
    { title: "100% - Fully Functioning" },
    { title: "75% - Connected" },
    { title: "50% - Installed" },
    { title: "25% - Supplies Procured" },
    { title: "0% - Not yet Started" },
  ];
  const options1 = [
    { title: "100% - Gardening" },
    { title: "75% - Levelling" },
    { title: "25% - location identified" },
    { title: "0% - Not yet Started" },
  ];
  const options2 = [
    { title: "100% - Appointed" },
    { title: "50% - Selected" },
    { title: "25% - Supplies Procured" },
    { title: "0% - Not yet Started" },
  ];
  const options3 = [
    { title: "100% - Fully Functioning" },
    { title: "75% - Connection to drip irrigation" },
    { title: "50% - Connection to sump" },
    { title: "25% - Location identified" },
    { title: "0% - Not yet Started" },
    { title: "NA" },
    { title: "Digging" },
    { title: "Bore well completed" },
    { title: "Not needed" },
  ];
  const options4 = [
    { title: "100% - Fully Functioning" },
    { title: "75% - Connected to Sump" },
    { title: "50% - Roof top connection" },
    { title: "25% - Supplies Procured" },
    { title: "0% - Not yet Started" },
    { title: "NA" },
  ];
  const options5 = [
    { title: "100% - Fully Functioning" },
    { title: "75% - Digging completed" },
    { title: "50% - Marking" },
    { title: "25% - Selection of location" },
    { title: "0% - Not yet Started" },
  ];
  const ucStatusOptions = [{ title: "Submitted" }, { title: "Not Submitted" }];
  const handleNumberChange = (name) => (e) => {
    const value = e.target.value;
    // Allow digits, commas, and dots
    if (/^[\d,.]*$/.test(value)) {
      formik.setFieldValue(name, value);
    }
  };
  const numbersOnly = (formik.values.hiring2 || "").toString().replace(/[^0-9]/g, "");
  const formatted = numbersOnly.replace(/(\d{1,2})$/g, ",$1");

  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    if (meData?.role_id === 3) {
      formik.setFieldValue("intDistrict", meData?.district);
      districtData = districtData.filter((obj) => obj.value === meData?.district);
      // console.log("districtData", districtData);
    }
    setDistricts(districtData);
  }, [meData]);

  // const [value, setValue] = useState(dayjs("2022-04-17"));
  return (
    <DashboardLayout>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
          style={{ color: "white" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Card id="delete-account">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h5" fontWeight="medium">
            Basic Info
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDTextField
                handleChange={formik.handleChange}
                name="txtGroup"
                placeholder="Enter Group (Phase)"
                displayName="Group (Phase)"
                required={false}
                formik={formik}
                maxLength={50}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDAutocomplete
                label="District"
                name="intDistrict"
                options={districts}
                formik={formik}
                required={false}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDTextField
                handleChange={formik.handleChange}
                name="txtSchoolName"
                placeholder="Enter School Name"
                displayName="School Name"
                required={false}
                formik={formik}
                inputType="onlyString"
                maxLength={255}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h4" fontWeight="bold" color="success">
            Hard Components
          </MDTypography>
        </MDBox>

        {/* <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h5" fontWeight="medium">
            Agriculture
          </MDTypography>
        </MDBox> */}
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDAutocomplete
                label="Solar Panel, Tubular battery/ Ongrid, lightings"
                name="txtAgri1"
                options={options}
                formik={formik}
                required={false}
              />
              {formik.values.txtAgri1 && formik.values.txtAgri1 !== "0% - Not yet Started" && (
                <MDBox mt={1}>
                  <MDTextField
                    handleChange={formik.handleChange}
                    name="txtAgri1Agency"
                    placeholder="Implementing Agency"
                    displayName="Implementing Agency"
                    formik={formik}
                  />
                </MDBox>
              )}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDAutocomplete
                label="Bore well, Drip Irrigation"
                name="txtAgri2"
                options={options3}
                formik={formik}
                required={false}
              />
              {formik.values.txtAgri2 && formik.values.txtAgri2 !== "0% - Not yet Started" && (
                <MDBox mt={1}>
                  <MDTextField
                    handleChange={formik.handleChange}
                    name="txtAgri2Agency"
                    placeholder="Implementing Agency"
                    displayName="Implementing Agency"
                    formik={formik}
                  />
                </MDBox>
              )}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <MDAutocomplete
                label="Rainwater Harvest"
                name="txtAgri3"
                options={options4}
                formik={formik}
                required={false}
              />
              {formik.values.txtAgri3 && formik.values.txtAgri3 !== "0% - Not yet Started" && (
                <MDBox mt={1}>
                  <MDTextField
                    handleChange={formik.handleChange}
                    name="txtAgri3Agency"
                    placeholder="Implementing Agency"
                    displayName="Implementing Agency"
                    formik={formik}
                  />
                </MDBox>
              )}
            </Grid>
          </Grid>
        </MDBox>
        {/* <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h5" fontWeight="medium">
            Horticulture
          </MDTypography>
        </MDBox> */}
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDAutocomplete
                label="Compost"
                name="horti1"
                options={options5}
                formik={formik}
                required={false}
              />
              {formik.values.horti1 && formik.values.horti1 !== "0% - Not yet Started" && (
                <MDBox mt={1}>
                  <MDTextField
                    handleChange={formik.handleChange}
                    name="horti1Agency"
                    placeholder="Implementing Agency"
                    displayName="Implementing Agency"
                    formik={formik}
                  />
                </MDBox>
              )}
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDAutocomplete
                label="Vegetable Garden, Medicinal garden, Planting of fruit bearing trees"
                name="horti2"
                options={options1}
                formik={formik}
                required={false}
              />
              {formik.values.horti2 && formik.values.horti2 !== "0% - Not yet Started" && (
                <MDBox mt={1}>
                  <MDTextField
                    handleChange={formik.handleChange}
                    name="horti2Agency"
                    placeholder="Implementing Agency"
                    displayName="Implementing Agency"
                    formik={formik}
                  />
                </MDBox>
              )}
            </Grid>
          </Grid>
        </MDBox>

        <MDBox pt={4} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h4" fontWeight="bold" color="success">
            Soft Components
          </MDTypography>
        </MDBox>

        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h5" fontWeight="medium">
            Hiring
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDAutocomplete
                label="Garden Maintenance"
                name="hiring1"
                options={options2}
                formik={formik}
                required={false}
              />
            </Grid>
          </Grid>
        </MDBox>

        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" aligns="center">
          <MDTypography variant="h5" fontWeight="medium">
            Green Ideas & Awareness
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTextField
                formik={formik}
                name="hiring2"
                placeholder="Enter Completed (Nos.)"
                displayName="Completed (Nos.)"
                required={false}
                inputType={"onlyNumbers"}
                maxLength={20}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Tentative Date of Inspection
              </MDTypography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={calendarOpen}
                  onOpen={() => setCalendarOpen(true)}
                  onClose={() => setCalendarOpen(false)}
                  value={formik.values.txtTentativeDate}
                  format="DD/MM/YYYY"
                  onChange={(value) => formik.setFieldValue("txtTentativeDate", value)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      onClick: () => setCalendarOpen(true),
                      error:
                        formik.touched.txtTentativeDate && Boolean(formik.errors.txtTentativeDate),
                      helperText: formik.touched.txtTentativeDate && formik.errors.txtTentativeDate,
                      InputProps: {
                        readOnly: true,
                        sx: {
                          fontSize: "14px",
                          height: "45px",
                          cursor: "pointer",
                          "& input": {
                            cursor: "pointer",
                          },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Remarks
              </MDTypography>
              <TextField
                name="remarks"
                value={formik.values.remarks}
                error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                fullWidth
                onChange={formik.handleChange("remarks")}
                placeholder="Enter Remarks"
                inputProps={{ maxLength: 5000 }}
                multiline
                rows={4}
                helperText={
                  formik.touched.remarks && formik.errors.remarks
                    ? formik.errors.remarks
                    : `${(formik.values.remarks || "").length} / 5000`
                }
                FormHelperTextProps={{
                  sx: {
                    textAlign: "right",
                    marginRight: 0,
                    display: "block",
                    fontSize: "0.75rem",
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Total Committed Expenditure (paid or yet to pay) in Rs.
              </MDTypography>
              <TextField
                name="Expenditure"
                value={formik.values.Expenditure}
                error={formik.touched.Expenditure && Boolean(formik.errors.Expenditure)}
                fullWidth
                onChange={handleNumberChange("Expenditure")}
                placeholder="Enter Amount (Rs.)"
                inputProps={{ maxLength: 100 }}
                helperText={
                  formik.touched.Expenditure && formik.errors.Expenditure
                    ? formik.errors.Expenditure
                    : `${(formik.values.Expenditure || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Total Unused Amount(expected or present)in Rs.
              </MDTypography>
              <TextField
                name="Amount"
                value={formik.values.Amount}
                error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                fullWidth
                onChange={handleNumberChange("Amount")}
                placeholder="Enter Amount (Rs.)"
                inputProps={{ maxLength: 100 }}
                helperText={
                  formik.touched.Amount && formik.errors.Amount
                    ? formik.errors.Amount
                    : `${(formik.values.Amount || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>

            {/* New Financial Fields */}
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Amount Received
              </MDTypography>
              <TextField
                name="amountReceived"
                value={formik.values.amountReceived}
                error={formik.touched.amountReceived && Boolean(formik.errors.amountReceived)}
                fullWidth
                onChange={handleNumberChange("amountReceived")}
                placeholder="Enter Amount Received"
                inputProps={{ maxLength: 100 }}
                helperText={
                  (formik.touched.amountReceived && formik.errors.amountReceived) ||
                  `${(formik.values.amountReceived || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Expenditure incurred
              </MDTypography>
              <TextField
                name="expenditureIncurred"
                value={formik.values.expenditureIncurred}
                error={
                  formik.touched.expenditureIncurred && Boolean(formik.errors.expenditureIncurred)
                }
                fullWidth
                onChange={handleNumberChange("expenditureIncurred")}
                placeholder="Enter Expenditure incurred"
                inputProps={{ maxLength: 100 }}
                helperText={
                  (formik.touched.expenditureIncurred && formik.errors.expenditureIncurred) ||
                  `${(formik.values.expenditureIncurred || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Expenditure to be incurred (Yet to pay)
              </MDTypography>
              <TextField
                name="expenditureToBeIncurred"
                value={formik.values.expenditureToBeIncurred}
                error={
                  formik.touched.expenditureToBeIncurred &&
                  Boolean(formik.errors.expenditureToBeIncurred)
                }
                fullWidth
                onChange={handleNumberChange("expenditureToBeIncurred")}
                placeholder="Enter Expenditure to be incurred"
                inputProps={{ maxLength: 100 }}
                helperText={
                  (formik.touched.expenditureToBeIncurred &&
                    formik.errors.expenditureToBeIncurred) ||
                  `${(formik.values.expenditureToBeIncurred || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MDTypography style={{ fontSize: "16px" }} color="dark">
                Balance available
              </MDTypography>
              <TextField
                name="balanceAvailable"
                value={formik.values.balanceAvailable}
                error={formik.touched.balanceAvailable && Boolean(formik.errors.balanceAvailable)}
                fullWidth
                onChange={handleNumberChange("balanceAvailable")}
                placeholder="Enter Balance available"
                inputProps={{ maxLength: 100 }}
                helperText={
                  (formik.touched.balanceAvailable && formik.errors.balanceAvailable) ||
                  `${(formik.values.balanceAvailable || "").length} / 100`
                }
                FormHelperTextProps={{
                  sx: { textAlign: "right", marginRight: 0, display: "block", fontSize: "0.75rem" },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <MDAutocomplete
                label="UC - Status"
                name="ucStatus"
                options={ucStatusOptions}
                formik={formik}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox p={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Grid xs={12} md={12} textAlign="right">
              <MDButton
                // color="#2f2f34 !important"
                onClick={async () => {
                  const errors = await formik.validateForm();
                  if (errors && Object.keys(errors).length > 0) {
                    const firstErrorField = Object.keys(errors)[0];
                    const firstErrorMessage = errors[firstErrorField];
                    setState((prevState) => ({
                      ...prevState,
                      open: true,
                      severity: "error",
                      message: `Validation Error: ${firstErrorMessage}`,
                    }));
                  }
                  formik.handleSubmit();
                }}
                sx={{
                  color: "white !important",
                  backgroundColor: "#16610E",
                  "&:hover": {
                    backgroundColor: "#1f1f22", // optional: darker on hover
                  },
                }}
              >
                {schoolId ? "Update" : "Submit"}
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default GreenSchoolAdd;
